import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const AreaList = Loadable(lazy(() => import("./AreaList")));
const AreaForm = Loadable(lazy(() => import("./AreaForm")));

const areaRoutes = [
  {
    path: "/Area/AreaList",
    element: <AreaList />,
    permission: PERMISSIONS.Areas.Menu,
  },
  {
    path: "/Area/AreaForm",
    element: <AreaForm />,
  },
  {
    path: "/Area/AreaForm/:areaId",
    element: <AreaForm />,
  },
];

export default areaRoutes;
